/** Default sort order for the Astera oncology external table API requests. */
export const ASTERA_ONCOLOGY_EXTERNAL_DEFAULT_ORDER_BY = [
  { column: "dumped_at", direction: "DESC" as const },
  { column: "patient_name", direction: "ASC" as const },
];

/** Request payload shape for Astera oncology external BigQuery table fetches. */
export interface AsteraOncologyExternalFilterPayload {
  filters?:
    | {
        seq?: string[];
        dumped_at?: string[];
        [key: string]: any;
      }
    | Record<string, any>;
  case_sensitive?: boolean;
  page: number;
  page_size?: number;
  request_id?: string;
  order_by?: { column: string; direction: "ASC" | "DESC" }[];
}
